import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

const UnstyledPhoneLink = dynamic(() => import('./unstyled-phone-link'));

Builder.registerComponent(UnstyledPhoneLink, {
  name: 'UnstyledPhoneLink',
  noWrap: true,
  inputs: [
    {
      name: 'includeTTY',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Include TTY',
    },
  ],
});
